export default {
  description: '',
  promotionProcessing: false,
  overrideTextRegular: null,
  overrideTextPromotion: null,
  price: {
    /* amount: 9.9, */
    chargingIntervalFactor: 1,
    chargingIntervalOverrideText: null,
    chargingIntervalUnit: 3,
    currency: 'EUR',
    isExact: true,
    minimumCommitmentPeriodFactor: 24,
    minimumCommitmentPeriodUnit: 3,
    priceDisplay: '9,90 €',
    value: '9.90',
    promotion: {
      /* amount: 4.5, */
      currency: 'EUR',
      durationFactor: 1,
      durationUnit: 3,
      priceDisplay: '4,50 €',
      promotionEnd: null,
      value: '4.50',
    },
  },
};
